@let focusContents = !header() && !subheader() && !secondarySubheader();

<div data-testid="component-card" [class.page-container]="isPageContainer()" [ngClass]="pageContainerSize()">
  <div class="relative bg-white border border-gray-200 rounded-lg shadow p-5" [class.page-card]="isPageContainer()">
    @if (header(); as title) {
      <h1 data-testid="component-card-title" class="mb-2 text-2xl font-bold tracking-tight text-gray-900 text-center">{{ title }}</h1>
    }

    @if (subheader(); as subtitle) {
      <p data-testid="component-card-subtitle" class="font-normal text-gray-700 text-center">
        {{ subtitle }}
      </p>
    }

    @if (secondarySubheader(); as subtitle) {
      <p data-testid="component-card-secondary-subtitle" class="font-normal text-gray-700 text-center">
        {{ subtitle }}
      </p>
    }

    <div class="absolute top-5 left-5">
      <ng-content select="[leftActions]"></ng-content>
    </div>

    <div class="md:absolute md:top-5 md:right-5 sm:justify-center flex gap-2">
      <ng-content select="[rightActions]"></ng-content>
    </div>

    <div [class.pt-4]="!focusContents">
      <ng-content></ng-content>
    </div>
  </div>
</div>
